import React from 'react';
import Section from './Section';
import { profile, aboutMore } from '../data/content';

const About = ({ about }) => {
  return (
    <Section id="about" title="About" subtitle="Who I am">
      <div className="grid two">
        <div>
          <p className="muted">
            {about || `${profile.summary}`}
          </p>
          <p className="muted" style={{ marginTop: '0.6rem' }}>
            {aboutMore}
          </p>
        </div>
        <div className="about-cards">
          <div className="card glass">
            <h3>Focus Areas</h3>
            <ul className="tags">
              <li>React</li>
              <li>Next.js</li>
              <li>TypeScript</li>
              <li>Flutter</li>
              <li>Dart</li>
              <li>Node.js</li>
            </ul>
          </div>
          <div className="card glass">
            <h3>What I value</h3>
            <ul className="bullets">
              <li>Pragmatic problem solving</li>
              <li>Accessible design</li>
              <li>Performance first</li>
              <li>Clean, maintainable code</li>
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default About;
